import { Outlet, Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import { Box, Container, Flex, HStack, Link, Button } from "@chakra-ui/react";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

const tabs = [
  { to: "/admin", label: "Products" },
  { to: "/admin/categories", label: "Categories" },
  { to: "/admin/hero-slides", label: "Hero Slides" },
  { to: "/admin/featured-carousels", label: "Featured Carousels" },
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <Box bg="rs.bg" minH="100vh">
      <Box borderBottom="1px solid" borderColor="rs.border" bg="rs.surface">
        <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
          <Flex h="60px" align="center" justify="space-between">
            <HStack spacing={6}>
              {tabs.map((tab) => {
                const isActive = location.pathname === tab.to;
                return (
                  <Link
                    key={tab.to}
                    as={RouterLink}
                    to={tab.to}
                    fontSize="13px"
                    fontWeight="500"
                    color={isActive ? "rs.red" : "rs.textMuted"}
                    _hover={{ color: "rs.text" }}
                  >
                    {tab.label}
                  </Link>
                );
              })}
            </HStack>
            <Button size="sm" variant="outline" onClick={handleLogout}>
              Log out
            </Button>
          </Flex>
        </Container>
      </Box>

      <Container maxW="container.xl" px={{ base: 4, md: 6 }} py={10}>
        <Outlet />
      </Container>
    </Box>
  );
};

export default AdminLayout;
